export default {
  debug: false,
  storage: {
    key: 'jp.meishibank2'
  },
  sessionStorage: {
    key: 'jp.meishibank2'
  },
  flags: {
    appsIntegrate: false
  },
  googlemap: {
    baseUrl: 'https://www.google.com/maps/search/?api=1&query='
  },
  help: {
    url: 'http://help.neomeishi.dev.jp/index.html'
  }
}

export const repository = {
  baseURL: 'http://172.17.2.33/v2',
  timeout: 30000,
  cacheKey: '_c'
}



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 1